import { render, staticRenderFns } from "./CommissionDetailModal.vue?vue&type=template&id=01f44c21&"
import script from "./CommissionDetailModal.vue?vue&type=script&lang=js&"
export * from "./CommissionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports